const CommonMail = require( 'common/mailBox/view' );

class wuhaiCommonmailBox extends CommonMail {
  constructor() {
    super( {
      events: {
        'click .reset-btn': 'resetEvent',
        'click .search-btn': 'doSearch'
      }
    } );
    this.initPage();
  }

  initPage() {
    this.initDate();
  }

  resetEvent() {
    $( '.block__search_wrap' )[ 0 ].reset();
    this.doSearch();
  }

  doSearch() {
    const keyword = this.$el.find( 'input[name="keyword"]' ).val();
    const beginTime = this.$el.find( 'input[name="replyDateStart"]' ).val();
    const endTime = this.$el.find( 'input[name="replyDateEnd"]' ).val();
    ;
    const requestData = {
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      begin: Date.parse( beginTime ) - ( 8 * 60 * 60 * 1000 ),
      end: Date.parse( endTime ) + ( ( 16 * 60 * 60 * 1000 ) - 1 ),
      keyword,
      type: this.type
    };
    this.fetchData( requestData );
  }


  initDate() {
    const $date = $( '.date-range .date' );
    $date.datetimepicker( {
      format: 'yyyy-mm-dd',
      autoclose: true,
      maxView: 4,
      minView: 2,
      language: 'zh-CN'
    } );
  }
}

module.exports = wuhaiCommonmailBox;

